// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6604f002","850":"31eaa113"}[chunkId] + ".chunk.js";
};